import DetailContent from '@/features/shared/DetailContent';
import useIsMobile from '@/features/shared/Hooks/useIsMobile';
import { MuiTab, MuiTabs, MuiTypography } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { BaseSyntheticEvent, useEffect, useState } from 'react';
import TabPanel from './components/TabPanel';
import { TabbedListContentProps } from './TabbedListContent.interfaces';
import useTabbedListContentStyles from './TabbedListContent.styles';
import { withGTM } from '@/features/shared/HOCs';
import {
  onDatalayerTabClick,
  tabbedEventTargets,
} from '@/features/shared/portal/TabbedListContent/TabbedListContent.datalayer';

const TabbedListContent = ({ content, className: overrideClassName }: TabbedListContentProps) => {
  const { tabContent = [], tabGroupTitle } = content;
  const isMobile = useIsMobile();

  const [tabValue, setTabValue] = useState<number>(0);
  const classes = useTabbedListContentStyles();

  const handleChangeTab = (event: BaseSyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    // resetting the index value on props changed
    setTabValue(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  return (
    <div
      className={clsx('tabbed-list-content', classes.root, overrideClassName)}
      key={JSON.stringify(content)}
    >
      {tabGroupTitle && (
        <MuiTypography variant="h4" component="h4" className={classes.heading}>
          {tabGroupTitle}
        </MuiTypography>
      )}
      <div className="tabs-header">
        <MuiTabs
          value={tabValue}
          onChange={handleChangeTab}
          variant="scrollable"
          scrollButtons={isMobile ? 'on' : 'off'}
          className="tabbed-list-content-tabs"
        >
          {tabContent.map((tab: DetailContentType<TabContentType>, index) => (
            <MuiTab
              id={`tabbed-id-${index}`}
              label={tab.tabTitle?.text}
              className={clsx(classes.tab, 'gtm-tab')}
              key={index}
            />
          ))}
        </MuiTabs>
      </div>
      <div className="tabs-content">
        {tabContent.map((tab: DetailContentType<TabContentType>, index) => (
          <TabPanel value={tabValue} index={index} key={index}>
            <DetailContent content={tab?.tabDetailContent?.detailContent} theme={Theme.dark} />
          </TabPanel>
        ))}
      </div>
    </div>
  );
};

export const GmtTabbedListContent = withGTM({
  Component: TabbedListContent,
  onDatalayer: onDatalayerTabClick,
  config: { mapTarget: tabbedEventTargets },
});

export default TabbedListContent;
